
import { defineComponent } from 'vue'
import { WeveSpinner } from '@weve/ui'

import useLoading from '../use/useLoading'

export default defineComponent({
  name: 'GlobalLoading',
  components: {
    WeveSpinner,
  },
  setup() {
    const { loading } = useLoading()
    return { loading }
  },
})
